import type { ExistingOptionI18nQuery, LangCode } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { NameOfResourceBeingEdited } from "@/components/features/_components";
import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";
import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithCategory,
} from "@/components/features/_layouts";

import { ProductExistingOptionI18nFormModelContextProvider } from "./context";
import { useInitialized } from "../../model/usecase/existing/use-init";
import { OptionI18nForm } from "../components/root";
import { standardOptionI18nCategoriesAndManagerStore } from "../store/categories";
import { HeaderUpdateButton } from "./components/header/update-button/update-button";

type Props = {
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
	serverModel: ExistingOptionI18nQuery;
};

export const OptionI18nEditPresenter = ({ activeLangCode, navigator, serverModel }: Props) => {
	const init = useInitialized({ serverModel });

	const { categoryManagerStore } = standardOptionI18nCategoriesAndManagerStore;

	const { isDirty } = init.viewModel;
	useTransitionBlock(isDirty);

	const optionName = init.viewModel.name.value;

	return (
		<ProductExistingOptionI18nFormModelContextProvider value={{ ...init }}>
			<FeatureIslandContainer>
				<FeatureIslandHeader
					title="オプション在庫の設定"
					activeLangCode={activeLangCode}
					navigator={navigator}
					rightChildren={<HeaderUpdateButton />}
				/>
				<FeatureIslandMainWithCategory categoryManagerStore={categoryManagerStore}>
					{/* @todo Layout の共通化が出来るまでは共通化しない */}
					<NameOfResourceBeingEdited resourceName={optionName} />

					<OptionI18nForm
						standardOptionI18nCategoriesAndManagerStore={standardOptionI18nCategoriesAndManagerStore}
					/>
				</FeatureIslandMainWithCategory>
			</FeatureIslandContainer>
		</ProductExistingOptionI18nFormModelContextProvider>
	);
};

OptionI18nEditPresenter.displayName = "OptionI18nEditPresenter";
